import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary, Paper, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

function SystemNews() {
  const classes = useStyles();

    const changelog = [
        {
            date: '2026-09-13',
            items: [
                'Možnost vygenerovat výkaz práce maséra celý i po jednotlivých organizacích (pro správce)',
                'Přidáno tlačítko "Přejít na datum" ve vyhledávání v kalendáři pro snadnější přechod na daný týden masáže'
            ]
        },
        {
            date: '2026-04-25',
            items: [
                'Vyhledávání podle nejbližšího volného termínu maséra'
            ]
        },
        {
            date: '2026-04-18',
            items: [
                'Přidána automatická kontrola duplicitních účtenek (spouští se večer)'
            ]
        },
        {
            date: '2026-02-15',
            items: [
                'Vylepšení zdrojového kódu',
                'Řazení podle data rezervace, příjmení a jména ve vyhledávání v kalendáři',
                'Deaktivace typu a ceny masáže, pokud není vybrán typ platby'
            ]
        },
        {
            date: '2025-05-11',
            items: [
                'Přejmenování jednoho kalendáře na „Masáže firem“',
                'Možnost odebrání uživatele z organizace',
                'Přesun ikony profilu a odhlášení pod „Můj profil“',
                'Přidána možnost změny hesla'
            ]
        },
        {
            date: '2025-04-19',
            items: [
                'Pro recepční: prodloužení kontroly nezaplacené masáže o 20 minut',
                'Přidání sekce „Můj profil“ (jméno, příjmení, nastavení)',
                'Funkce „Zapomenuté heslo“'
            ]
        },
        {
            date: '2025-01-15',
            items: [
                'Oprava layoutu přihlašovacího formuláře'
            ]
        },
        {
            date: '2024-09-25',
            items: [
                'Seřazení uživatelů podle role a stavu (aktivní/neaktivní)',
                'Úprava barev tlačítek',
                'Úprava vyskakovacích oken (chyby, upozornění, potvrzení)',
                'Oprava načítání recepčních a masérů při změně organizace',
                'Skrytí výběru organizace a masérny při jediné dostupné možnosti'
            ]
        },
        {
            date: '2024-09-16',
            items: [
                'Přidání nastavení maséren pro umožnění 30minutových masáží'
            ]
        },
        {
            date: '2024-09-04',
            items: [
                'Přihlášení pomocí Enteru',
                'Seřazení uživatelů podle stavu (aktivní/neaktivní)',
                'Kontrola smazání již použité permanentky',
                'Mazání plateb při smazání permanentky nebo dárkového poukazu'
            ]
        },
        {
            date: '2024-03-23',
            items: [
                'Drobné stylové úpravy'
            ]
        },
        {
            date: '2024-03-02',
            items: [
                'Změna názvu masáže (permanentka, dárkový poukaz) v pokladním dokladu',
                'Oprava odhlášení a výpisu plateb'
            ]
        },
        {
            date: '2024-01-20',
            items: [
                'Úprava logiky uplatnění poukazů kvůli výkonu (+ přidán sloupec „applied“ v rezervacích)'
            ]
        }
    ];

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1>Novinky v aplikaci</h1>
          <Alert severity="warning" sx={{ mb: 2 }}>
              <AlertTitle>Dočasné omezení zobrazení rezervací</AlertTitle>
              V kalendáři se aktuálně zobrazují pouze rezervace od 1. 1. 2025.
              Toto omezení se vztahuje jak na zobrazení rezervací v kalendáři,
              tak na jejich vyhledávání. Jedná se o dočasné opatření
              z důvodu optimalizace výkonu systému.
          </Alert>
        {changelog.map(log => (
            <Accordion>
              <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1-content'
                  id='panel1-header'
              >
                <Typography component='span'>
                  {log.date}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <ul>
                  {log.items.map((item, index) => (
                      <li key={index}>{item}</li>
                  ))}
                </ul>
              </AccordionDetails>
            </Accordion>
        ))}
      </Paper>
    </div>
);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    padding: '2em'
  }
}));


export default SystemNews;
